import React, { useState, useRef, useEffect } from "react";
import moment from 'moment';
import { Card, Row, Col, Overlay, Tooltip, OverlayTrigger, Image, Table } from 'react-bootstrap';
import Filedownload from 'js-file-download';
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { BsCaretDownFill} from "react-icons/bs";
import DOMPurify from "dompurify";
import userImage from "../assets/user.png";
import ApiService from "../ApiService";
import MessageTestDetail from "./MessageTestDetail";
import { getSenderName, getSenderInitial } from "../util/common";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MessageReplyChain = (props) => {
    const message = props.message
    const parentUUID = props.message.messageParentUUID
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [patientDetail, setPatientDetail] = useState(null)
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("");
    const [snackText, setSnackText] = useState("");

    useEffect(() => {
        const userSubId =
          message?.fromField === "PATIENT"
            ? message?.fromId
            : message?.toField === "PATIENT"
            ? message?.toUsers.find(user => user.addresseeType === "PATIENT")?.userId
            : message?.toIds[0];

        if (userSubId && message?.messageType !== "BELUGA") {
          ApiService.getPatientDetailsBySubId(userSubId)
            .then(res => {
              if (res?.data) setPatientDetail(res.data);
            })
            .catch(err => {
              console.error(err);
            });
        }
      }, [message]);
    
    const handleSnackOpen = (text, severity) => {
        setSnackSeverity(severity);
        setSnackText(text);
        setSnackOpen(true);
    };

    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    const download = async (fileName) => {
        if (!fileName) {
            return;
        }
        await ApiService.downloadFile('MESSAGE_ATTACHMENTS', fileName)
            .then(resp => {
                Filedownload(resp.data, fileName.substring(fileName.indexOf('_') + 1));
            })
            .catch(async (error) => {
                const data = error?.response?.data;
                if (
                    error?.request?.responseType === 'blob' &&
                    data instanceof Blob &&
                    data?.type &&
                    data.type.toLowerCase().indexOf('json') != -1
                ) {
                    const errorString = JSON.parse(await data?.text());
                    handleSnackOpen(errorString?.reason, "error");
                }
            });
    };

    if (!message) {
        return (<div className="open_message load_message"><i className="fas fa-spinner fa-pulse"></i></div>)
    } else {
        return (
            <div>
                {message.parentMsgsSorted.map((index) => 
                    <div>
                        <Card.Title as={Row} className="msgSubject">
                        <Col className="titleInfo">
                        </Col>
                    </Card.Title>
                    <Card.Text>
                    <Row className="msgFromUser">
                        <div className="msgFromUserBig">
                        <OverlayTrigger
                                placement="bottom"
                                overlay={
                                <Tooltip className="profileTooltip">
                                    <Row className="profileCard">
                                        <Col md={3}>
                                            <div>
                                            {
                                                <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage}/>
                                            }
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                                <div className="userName">
                                                {getSenderName(index, patientDetail)}
                                            </div>
                                            <div>
                                                {index?.fromUser?.phoneNumber}
                                            </div>
                                            <div>
                                                {index?.fromUser?.email}
                                            </div>
                                        </Col>
                                    </Row> 
                                </Tooltip>
                                }
                            >
                            <div>{getSenderInitial(index, patientDetail)}</div>
                        </OverlayTrigger>
                    </div>
                        <Col md={7}>
                            <p className="msgFromUserFull">{getSenderName(index, patientDetail)}</p>
                            <p className="msgToUser">To: {index?.toNames?.toString().substring(0, 50)}... <span ref={target} onClick={() => setShow(!show)}> <BsCaretDownFill/></span></p>
                            <p className="msgToUser">CC: {index?.ccToGroupNames?.toString().substring(0, 50)}</p>
                        </Col>
                        <Col className="text-right" md={4}>
                            <p className="msgToUser">{moment(index.createdDateTime).format("ddd MMM D, YYYY LT")}</p>
                        </Col>
                    </Row>
                    <div dangerouslySetInnerHTML={{
                                __html: index?.messageType === 'TEST_RESULT' ? DOMPurify.sanitize(index?.testResult?.externalNotes) : DOMPurify.sanitize(index?.content)
                            }}
                        className="message_text">
                    </div>
                            
                    {index?.messageType === 'TEST_RESULT' && <MessageTestDetail message={index} displayOnlyTestResults />}
                            
                    {index?.attachmentUrls?.length > 0 ? (
                        <div>
                            {index.attachmentUrls.map((item) => (
                                <div className="attachment-files" onClick={() => download(item)}>
                                    <div className="file-name-text">
                                        {item?.substring(item?.indexOf('_') + 1)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : null}
                    </Card.Text>
                    <hr></hr>
                        <Overlay target={target.current} show={show} placement="right">
                        {(props) => (
                        <Tooltip {...props}>
                            <Row className="overlayCard">
                                <Table size="sm" className="tooltipTable">
                                    <tbody>
                                        <tr className="tabRow">
                                            <td className="colText">
                                                From:
                                            </td>
                                            <td className="colText">
                                            {getSenderName(index, patientDetail)}
                                            </td>
                                        </tr>
                                        <tr className="tabRow">
                                            <td className="colText">
                                                To:
                                            </td>
                                            <td className="colText">
                                                {index?.toNames?.toString()}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Row>
                        </Tooltip>
                        )}
                    </Overlay>
                    </div>
                )}
                <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                    <Alert onClose={handleSnackClose} severity={snackSeverity}>
                        {snackText}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}

export default MessageReplyChain;